import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, campaignFetched, campaignCalloutsFetched, activeChannelsFetched } from './duck';
import { campaignEndpoint, campaignCalloutsEndpoint, campaignActiveChannelsEndpoint } from './selectors';

export function* fetchCampaign(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(campaignEndpoint, action.payload)
            }
        );

        yield put(campaignFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchCampaignCallouts(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(campaignCalloutsEndpoint, action.payload)
            }
        );

        yield put(campaignCalloutsFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchActiveChannels(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(campaignActiveChannelsEndpoint, action.payload)
            }
        );

        yield put(activeChannelsFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* campaignSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH, fetchCampaign, api),
        takeLatest(actions.FETCH_CALLOUTS, fetchCampaignCallouts, api),
        takeLatest(actions.FETCH_ACTIVE_CHANNELS, fetchActiveChannels, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/campaign/saga.js